var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "entrustService" }, [
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      本协议是亦邦物流网络平台注册用户（包括使用亦邦物流网络平台的个人和所代表的企业）与亦邦物流网络平台之间的法律契约，注册亦邦物流网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即亦邦物流用户）且自发出协议之时即受协议条款的约束。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      本协议文中的亦邦物流是本协议的契约方之一。下文中的“用户”指亦邦物流网络平台注册用户，是本协议的契约方之另一方。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      用户欲访问和使用亦邦物流网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制亦邦物流网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消亦邦物流网络平台提供的服务。对亦邦物流网络平台的使用行为将被视为对本协议条款的完全接受，包括接受亦邦物流网络平台对条款所做的任何修改。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      鉴于用户有货物出口需求，亦邦物流具备货物组织及出口业务操作能力，双方经友好协商，依据《中华人民共和国民法典》等相关法律法规，就用户委托亦邦物流代理出口货物事宜达成如下协议：\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_title" }, [_vm._v("一、委托事项")]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      用户以自身名义出具相关出口单据，包括但不限于商业发票、装箱单、合同等，亦邦物流负责办理货物的出口手续。亦邦物流按照本协议约定，收取用户支付的费用。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_title" }, [_vm._v("二、费用结算")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "paragraph_con", staticStyle: { color: "#409eff" } },
          [_vm._v("根据双方协商为准")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_title" }, [
          _vm._v("三、权利和义务")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_part" }, [
          _c("div", { staticClass: "paragraph_part_title" }, [
            _vm._v("（一）用户权利和义务")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c("div", { staticClass: "part_child_title" }, [_vm._v("权力")]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          1.有权要求亦邦物流按照本协议约定完成货物出口手续。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v("2.有权了解货物出口的进展情况")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c("div", { staticClass: "part_child_title" }, [_vm._v("义务")]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          1.按照本协议约定的时间和金额支付费用。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          2.向亦邦物流提供真实、准确的货物信息和相关文件，包括但不限于品名、规格、数量、货值、原产地等均真实、准确、合法、有效，并符合海关、税务、外汇管理等国家监管机构的要求，协助亦邦物流办理出口手续。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          3.不得擅自与亦邦物流以外的第三方就本协议项下的货物出口业务进行合作。\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_part" }, [
          _c("div", { staticClass: "paragraph_part_title" }, [
            _vm._v("（二）亦邦物流权力和义务")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c("div", { staticClass: "part_child_title" }, [_vm._v("权力")]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          1.有权按照本协议约定收取用户代理服务费用。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          2.在用户未按照本协议约定支付费用时，有权要求用户承担违约责任。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          3.有权要求用户提供必要的协助和支持，以完成出口等手续。\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c("div", { staticClass: "part_child_title" }, [_vm._v("义务")]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          1.按照本协议约定的时间和标准办理货物出口手续，确保货物顺利通关。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          2.保守用户的商业秘密和货物信息，不得向任何第三方泄露。\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "part_child_con" }, [
              _vm._v(
                "\n          3.及时向用户通报出口的进展情况，配合用户完成货物出口业务。\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_title" }, [_vm._v("四、违约责任")]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_part" }, [
          _c("div", { staticClass: "paragraph_part_title" }, [
            _vm._v("（一）用户违约责任")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c(
              "div",
              {
                staticClass: "part_child_con",
                staticStyle: { "padding-left": "25px" }
              },
              [
                _vm._v(
                  "\n          1.若用户未按照本协议约定的时间和金额支付货款及各项费用，每逾期一日应按照未支付金额的0.5‰向亦邦物流支付违约金。逾期超过30日的，亦邦物流有权解除本协议，并要求用户赔偿因此造成的损失。\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "part_child_con",
                staticStyle: { "padding-left": "25px" }
              },
              [
                _vm._v(
                  "\n          2.若用户提供的货物信息、货值或相关文件不真实、不准确，导致货物出口业务无法顺利进行或产生损失的，用户应承担全部赔偿责任，若亦邦物流因此遭受损失，用户应当全部赔偿。\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_part" }, [
          _c("div", { staticClass: "paragraph_part_title" }, [
            _vm._v("（二）亦邦物流违约责任")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "paragraph_part_child" }, [
            _c(
              "div",
              {
                staticClass: "part_child_con",
                staticStyle: { "padding-left": "25px" }
              },
              [
                _vm._v(
                  "\n          1.若亦邦物流未按照本协议约定的时间和标准办理货物出口手续，导致货物无法顺利通关或产生损失的，亦邦物流应承担直接损失的赔偿责任。\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "part_child_con",
                staticStyle: { "padding-left": "25px" }
              },
              [
                _vm._v(
                  "\n          2.若亦邦物流泄露用户的商业秘密和货物信息，给用户造成损失的，亦邦物流应承担直接损失的赔偿责任。\n        "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "paragraph" }, [
        _c("div", { staticClass: "paragraph_title" }, [_vm._v("五、争议解决")]),
        _vm._v(" "),
        _c("div", { staticClass: "paragraph_con" }, [
          _vm._v(
            "\n      本协议在履行过程中如发生争议，双方应首先友好协商解决；协商不成的，任何一方均有权向原告所在地有管辖权的人民法院起诉。败诉方承担胜诉方支出的法律费用（包括但不限于诉讼费、仲裁费、保全费、公证费、律师费）。\n    "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dfce4928", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfce4928","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./common/entrustService.vue
// module id = null
// module chunks = 